import { useOutletContext } from 'react-router-dom';

/** Measured heights of `AppShell`'s fixed top HUD and bottom dock, passed down via `Outlet context` (see `AppShell.tsx`). */
export interface ShellChrome {
    hudHeight: number;
    navHeight: number;
}

/**
 * Reads `AppShell`'s outlet context. A page rendered outside `AppShell`
 * (e.g. a dev harness) gets `{ hudHeight: 0, navHeight: 0 }` instead of
 * throwing, since `useOutletContext` returns `undefined` there.
 */
export function useShellChrome(): ShellChrome {
    const context = useOutletContext<ShellChrome | undefined>();
    return context ?? { hudHeight: 0, navHeight: 0 };
}

export default useShellChrome;
